import React, { useState } from 'react';
import './Leadership2.css';
import CEO from '../../assets/CEO.jpg'
import Shanti from '../../assets/shanti.jpg'
import lalitha from '../../assets/lalitha.jpg'
import sam from '../../assets/sam.jpg'
import nad from '../../assets/Nad.jpg'
import LK from '../../assets/LK.jpg'
import CFO from '../../assets/CFO.jpg'
import Abel from '../../assets/abel.jpg'
import ProfileModal from './ProfileModal'; // Import the modal
import cc from '../../assets/cc.jpg'
 import aa from '../../assets/aa.jpg'
 import bb from '../../assets/bb.jpg'

const leadershipImages = [
  {
    src:cc,
  },
  {
    src: CEO,
    name: "Sai Mudigonda",
      title: "Founder & CEO",
      role: "Founder & CEO",
      image: CEO,
      desc: "Sai Mudigonda leads Blukraft with a vision to redefine how organizations transform and scale. With global leadership experience across multiple continents, he brings a unique blend of strategic clarity, deep domain expertise, and people-centric innovation. His approach centers on partnering closely with businesses to drive meaningful, sustainable, and outcome-driven change. He believes that true transformation happens when expertise, collaboration, and purpose come together.",
      linkedin: "https://linkedin.com"
  },
  {
    src: Shanti,
   name: "Shanti Mudigonda",
      title: "Co-Founder & EVP",
      role: "Co-Founder & EVP",
      image: Shanti,
      desc: "Shanti Mudigonda ensures Blukraft’s vision translates into seamless execution across teams, processes, and global operations. Her leadership focuses on building resilient systems, strengthening organizational precision, and cultivating operational excellence that sustains growth at scale.With her disciplined yet people-first approach, she ensures that every initiative-strategic or operational-creates consistent value for both the company and its customers.",
      linkedin: "https://linkedin.com"
  },
  {
    src: lalitha,
     name: "Lalitha Kota",
      title: "Director-Global Operations",
      role: "Director-Global Operations",
      image: lalitha,
      desc: "With over a decade of experience in HR and Operations, Lalitha Kota bridges the gap between people, processes, and performance. She specializes in building operational frameworks that enhance efficiency, drive productivity, and support scalable global growth.Her focus on resilient teams, structured processes, and organizational agility ensures that Blukraft operates with consistency, cohesion, and a strong culture of excellence.",
      linkedin: "https://linkedin.com"
  },
  {
    src: sam,
    name: "Samson Jeremy",
      title: "Director-Solutions ",
      role: "Director-Solutions ",
      image: sam,
      desc: "With 13+ years of expertise in supply chain consulting, enterprise product engineering, and solution architecture, Samson Jeremy plays a pivotal role in shaping high-impact solutions at Blukraft. He brings a deep understanding of customer environments, enabling him to design architectures that simplify complexity and accelerate digital transformation. His strategic perspective ensures every solution is robust, scalable, and aligned with long-term business goals-making him a driving force in delivering measurable customer success.",
      linkedin: "https://linkedin.com"
  },
  {
    src: aa,
  },
  {
    src: CFO,
    name: 'Sri Kalyan',
    title: 'CFO',
    role: 'CFO',
    image: CFO,
    desc: 'CFO',
    linkedin: 'https://linkedin.com'
  },
  {
    src: nad,
    name: 'Nadesan Pillay',
    title: 'Regional Growth & Services Executive',
    role: 'Regional Growth & Services Executive',
    image: nad,
    desc: 'Marketing executive with proven growth strategies.',
    linkedin: 'https://linkedin.com'
  },
  {
    src: LK,
    name: 'Lakshmikanth Adidamu',
    title: 'Engineering Director',
    role: 'Engineering Director',
    image: LK,
    desc: 'Engineering Director',
    linkedin: 'https://linkedin.com'
  },
  
  {
    src: Abel,
    name: 'Abel Correa',
    title: 'Advisory Consultant',
    role: 'Advisory Consultant',
    image: Abel,
    desc: 'Advisory Consultant',
    linkedin: 'https://linkedin.com'
  },
  {
    src: bb,
  },
];
 
 
const LeadershipGrid = () => {
  const [selectedMember, setSelectedMember] = useState(null);
  const [showModal, setShowModal] = useState(false);
 
 
  const handleCardClick = (member) => {
    if (!member) return;
    setSelectedMember(member);
    setShowModal(true);
  };
 
 
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMember(null);
  };
 
 
  return (
    <>
      <section className="leadership-section">
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <h2 className="leadership-title">Our Leadership Team</h2>
              <p className="leadership-subtitle">Meet the team driving our success</p>
            </div>
          </div>
 
 
          {/* Row 1: 3 images only - First spans C1+C2, then C3, C4 untouched */}
          <div className="row g-4 mb-4">
            <div className="col-xl-6 col-lg-6 col-md-6 col-12">
              <div className="leadership-card h-100">
                <div className="leadership-image-wrapper">
                  <img
                    src={leadershipImages[0].src}
                    alt=""
                    className="leadership-image"
                  />
                </div>
              </div>
            </div>
 
 
            {/* (ceo) */}
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <div
                className="leadership-card h-100"
                onClick={() => handleCardClick(leadershipImages[1])}
              >
                <div className="leadership-image-wrapper">
                  <img
                    src={leadershipImages[1].src}
                    alt={leadershipImages[1].name}
                    className="leadership-image"
                  />
                  {/* Plus Icon - Bottom Right */}
                  <div className="plus-icon">
                    <span className="plus-line horizontal"></span>
                    <span className="plus-line vertical"></span>
                  </div>
                  <div className="leadership-overlay">
                    <div className="overlay-content">
                      <h6 className="leader-name">{leadershipImages[1].name}</h6>
                      <p className="leader-title">{leadershipImages[1].title}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
 
 
            {/*shanthi */}
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <div
                className="leadership-card h-100"
                onClick={() => handleCardClick(leadershipImages[2])}
              >
                <div className="leadership-image-wrapper">
                  <img
                    src={leadershipImages[2].src}
                    alt={leadershipImages[2].name}
                    className="leadership-image"
                  />
                  {/* Plus Icon - Bottom Right */}
                  <div className="plus-icon">
                    <span className="plus-line horizontal"></span>
                    <span className="plus-line vertical"></span>
                  </div>
                  <div className="leadership-overlay">
                    <div className="overlay-content">
                      <h6 className="leader-name">{leadershipImages[2].name}</h6>
                      <p className="leader-title">{leadershipImages[2].title}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
 
 
          {/* lalitha - Row 2 Column 1*/}
          <div className="row g-4 mb-4">
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <div
                className="leadership-card h-100"
                onClick={() => handleCardClick(leadershipImages[3])}
              >
                <div className="leadership-image-wrapper">
                  <img
                    src={leadershipImages[3].src}
                    alt={leadershipImages[3].name}
                    className="leadership-image"
                  />
                  {/* Plus Icon - Bottom Right */}
                  <div className="plus-icon">
                    <span className="plus-line horizontal"></span>
                    <span className="plus-line vertical"></span>
                  </div>
                  <div className="leadership-overlay">
                    <div className="overlay-content">
                      <h6 className="leader-name">{leadershipImages[3].name}</h6>
                      <p className="leader-title">{leadershipImages[3].title}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
 
 
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <div
                className="leadership-card h-100"
                onClick={() => handleCardClick(leadershipImages[4])}
              >
                <div className="leadership-image-wrapper">
                  <img
                    src={leadershipImages[4].src}
                    alt={leadershipImages[4].name}
                    className="leadership-image"
                  />
                  {/* Plus Icon - Bottom Right */}
                  <div className="plus-icon">
                    <span className="plus-line horizontal"></span>
                    <span className="plus-line vertical"></span>
                  </div>
                  <div className="leadership-overlay">
                    <div className="overlay-content">
                      <h6 className="leader-name">{leadershipImages[4].name}</h6>
                      <p className="leader-title">{leadershipImages[4].title}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
 
 
            {/* none - Row 2 Column 3 */}
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <div className="leadership-card h-100">
                <div className="leadership-image-wrapper">
                  <img
                    src={leadershipImages[5].src}
                    alt={leadershipImages[5].name}
                    className="leadership-image"
                  />
                  <div className="leadership-image-wrapper">
                    <div className="overlay-content">
                      <h6 className="leader-name">{leadershipImages[5].name || ''}</h6>
                      <p className="leader-title">{leadershipImages[5].title || ''}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
 
            {/* nad - Row 2 Column 4 */}
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <div
                className="leadership-card h-100"
                onClick={() => handleCardClick(leadershipImages[6])}
              >
                <div className="leadership-image-wrapper">
                  <img
                    src={leadershipImages[6].src}
                    alt={leadershipImages[6].name}
                    className="leadership-image"
                  />
                  {/* Plus Icon - Bottom Right */}
                  <div className="plus-icon">
                    <span className="plus-line horizontal"></span>
                    <span className="plus-line vertical"></span>
                  </div>
                  <div className="leadership-overlay">
                    <div className="overlay-content">
                      <h6 className="leader-name">{leadershipImages[6].name}</h6>
                      <p className="leader-title">{leadershipImages[6].title}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
 
 
          {/* Row 3 */}
          {/* <div className="row g-4 mb-4">
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <div
                className="leadership-card h-100"
                onClick={() => handleCardClick(leadershipImages[7])}
              >
                <div className="leadership-image-wrapper">
                  <img
                    src={leadershipImages[7].src}
                    alt={leadershipImages[7].name}
                    className="leadership-image"
                  />
                 
                  <div className="plus-icon">
                    <span className="plus-line horizontal"></span>
                    <span className="plus-line vertical"></span>
                  </div>
                  <div className="leadership-overlay">
                    <div className="overlay-content">
                      <h6 className="leader-name">{leadershipImages[7].name}</h6>
                      <p className="leader-title">{leadershipImages[7].title}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
 
 
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <div
                className="leadership-card h-100"
                onClick={() => handleCardClick(leadershipImages[8])}
              >
                <div className="leadership-image-wrapper">
                  <img
                    src={leadershipImages[8].src}
                    alt={leadershipImages[8].name}
                    className="leadership-image"
                  />
                 
                  <div className="plus-icon">
                    <span className="plus-line horizontal"></span>
                    <span className="plus-line vertical"></span>
                  </div>
                  <div className="leadership-overlay">
                    <div className="overlay-content">
                      <h6 className="leader-name">{leadershipImages[8].name}</h6>
                      <p className="leader-title">{leadershipImages[8].title}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
 
 
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <div
                className="leadership-card h-100"
                onClick={() => handleCardClick(leadershipImages[9])}
              >
                <div className="leadership-image-wrapper">
                  <img
                    src={leadershipImages[9].src}
                    alt={leadershipImages[9].name}
                    className="leadership-image"
                  />
            
                  <div className="plus-icon">
                    <span className="plus-line horizontal"></span>
                    <span className="plus-line vertical"></span>
                  </div>
                  <div className="leadership-overlay">
                    <div className="overlay-content">
                      <h6 className="leader-name">{leadershipImages[9].name}</h6>
                      <p className="leader-title">{leadershipImages[9].title}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
 
 
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <div className="leadership-card h-100">
                <div className="leadership-image-wrapper">
                  <img
                    src={leadershipImages[10]?.src || leadershipImages[0].src}
                    alt={leadershipImages[10]?.name || ''}
                    className="leadership-image"
                  />
                  <div className="leadership-overlay">
                    <div className="overlay-content">
                      <h6 className="leader-name">{leadershipImages[10]?.name || ''}</h6>
                      <p className="leader-title">{leadershipImages[10]?.title || ''}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
 
 
        </div>
      </section>
 
 
      {/* Profile Modal */}
      {showModal && selectedMember && (
        <ProfileModal
          member={selectedMember}
          onClose={handleCloseModal}
        />
      )}
    </>
  );
};
 
 
export default LeadershipGrid;